import globalConfig from './config';
import { listenState, waitForReady, waitForViewability } from './mraid-utils';
import { setTitle } from './title';
import { DebugLog } from './debug-log';

const infos: MraidInfos = {} as MraidInfos;

function setViewability(viewable: boolean | number) {
  DebugLog.log('setViewability called with viewability:', { viewable });
  if (typeof viewable === 'boolean') {
    infos.isViewable = viewable;
  } else if (typeof viewable === 'number') {
    infos.isViewable = viewable >= 50;
  }
  setTitle(infos);
}

function setState(state: string) {
  DebugLog.log('setState called with state:', { state });
  infos.state = state;
  setTitle(infos);
}

function onReady() {
  const currentState = window.mraid.getState();
  DebugLog.log('onReady called, current state:', { currentState });
  setState(currentState);
}

export function listenForMraidChanges() {
  if (window.mraid) {
    waitForReady(onReady);
    listenState(setState);
    waitForViewability(setViewability);
  }
}

export function initMraidInfos(formatName: any, campaignId: number) {
  infos.env = globalConfig.ENV;
  infos.hash = globalConfig.COMMIT_HASH;
  infos.formatName = String(formatName);
  infos.campaignId = campaignId;
  setTitle(infos);
}

export function getCurrentMraidInfos(): MraidInfos {
  return { ...infos };
}

export const __TESTS__ = {
  infos,
  LogDebug: DebugLog,
  setState,
  setViewability
};
